import React from 'react';
import ReactTable from "react-table";

const columns = [
    {
        Header: "Record Name",
        accessor: "name"
    },
    {
        Header: "Record Type",
        accessor: "type"
    },
    {
        Header: "Record Value",
        accessor: "data"
    }
];

const DnsSearchResult = ({ dnsSearchData }) => {
    return (<div>
        <h4>Domain Search Result</h4>
        <ReactTable
            data={dnsSearchData}
            columns={[{ Header: "Domain", accessor: "domain" }]}
            defaultPageSize={5}            
            SubComponent={row => <ReactTable
                columns={columns}
                data={row.original.records}
                defaultPageSize={row.original.records.length}
                showPagination={false}
            />}
        />
    </div>);
}

export default DnsSearchResult;


// WEBPACK FOOTER //
// ./src/components/DnsSearchRouteComponent/DnsSearchResult.js